export const TOAST_TYPES = ["info", "success", "fail"] as const
export const TOAST_ICON_SIZE = 16

export type ToastType = (typeof TOAST_TYPES)[number]
export type ToastInputType = ToastType | "neutral" | "error"

type ToastVariantConfig = {
  icon: "circle-check" | "info" | "triangle-alert"
  iconClassName: string
  className: string
  role: "alert" | "status"
}

export const TOAST_BASE_CLASS =
  "ui-toast box-border flex w-[calc(100vw-32px)] max-w-[600px] items-center gap-[8px] rounded-[var(--ui-border-radius-md)] border px-[12px] py-[16px] text-xs leading-[16px] text-dark dark:text-light"

export const TOAST_VARIANT_CONFIG: Record<ToastType, ToastVariantConfig> = {
  info: {
    icon: "info",
    iconClassName: "!text-[#595959] dark:!text-[#808080]",
    className: "border-[#595959] bg-[#E8E8E8] dark:border-[#808080] dark:bg-[#121212]",
    role: "status",
  },
  success: {
    icon: "circle-check",
    iconClassName: "!text-[#2B9412]",
    className: "border-[#2B9412] bg-[#DCF5D6] dark:border-[#257F0A] dark:bg-[#051C01]",
    role: "status",
  },
  fail: {
    icon: "triangle-alert",
    iconClassName: "!text-[#CC2222] dark:!text-[#E05C5C]",
    className: "border-[#CC2222] bg-[#FAD8D8] dark:border-[#E05C5C] dark:bg-[#2F0706]",
    role: "alert",
  },
}

export const TOASTER_CONTAINER_STYLE = {
  bottom: 40,
  left: 0,
  right: 0,
} as const

export const normalizeToastType = (type: ToastInputType): ToastType => {
  if (type === "neutral") return "info"
  if (type === "error") return "fail"
  return type
}
